import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromLocker from './locker.reducer';

export const selectLockerState = createFeatureSelector<fromLocker.State>(
  fromLocker.lockersFeatureKey
);

export const selectLockerProcessing = createSelector(
  selectLockerState,
  (state) => state.processing
);

export const selectMyLocker = createSelector(selectLockerState, (state) => ({
  bids: state.bids,
  nextPage: state.nextPage,
  firstPage: state.firstPage,
  section: state.section,
}));

export const selectMyLockerNextPage = createSelector(selectLockerState, (state) => ({
  nextBids: state.nextBids,
  nextPage: state.nextPage,
  section: state.section,
}));

export const selectLockerProcessingNextPage = createSelector(
  selectLockerState,
  (state) => state.processingNextPage
);
